import { render } from "./ManageClient.vue?vue&type=template&id=6455a682"
import script from "./ManageClient.vue?vue&type=script&lang=js"
export * from "./ManageClient.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__